// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/" + chunkId + ".main-" + {"199":"59184f","346":"fca96e","850":"2dde37"}[chunkId] + ".css";
};